export const PAYJP_API_PUBLIC_KEY = process.env.REACT_APP_PAYJP_API_PUBLIC_KEY!;
